import React from "react";

export default function ContentPreview({ contentJson }) {
    if (!contentJson) return null;

    return (
        <div className="max-w-3xl mx-auto">
            <div className="mb-4">
                <h2 className="text-lg font-bold">{contentJson.meta?.title || "پیش‌نمایش"}</h2>
                <p className="text-sm text-gray-500">
                    {contentJson.meta?.type || ""} • {contentJson.meta?.language || ""}
                </p>
            </div>

            <div className="space-y-6">
                {(contentJson.fragments || []).map((frag) => (
                    <div key={frag.id} className="p-4 rounded-2xl border bg-white">
                        <div className="text-xs text-gray-500 mb-3">{frag.id}</div>

                        <div className="space-y-4">
                            {(frag.blocks || []).map((b) => {
                                if (b.type === "text") return <p key={b.id}>{b.config?.text}</p>;
                                if (b.type === "image") return <div key={b.id} className="text-sm text-gray-500">[image: {b.config?.url}]</div>;
                                if (b.type === "mcq") return (
                                    <div key={b.id} className="p-3 rounded-xl border bg-gray-50">
                                        <div className="font-medium">{b.config?.question}</div>
                                        <ul className="mt-2 list-disc pr-5">
                                            {(b.config?.options || []).map((opt, i) => <li key={i}>{opt}</li>)}
                                        </ul>
                                    </div>
                                );
                                if (b.type === "code") return (
                                    <pre key={b.id} className="p-3 rounded-xl border bg-gray-50 overflow-auto">
                    <code>{b.config?.code?.starter || ""}</code>
                  </pre>
                                );
                                return <div key={b.id} className="text-gray-500 text-sm">[{b.type}]</div>;
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
